var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTextListNumbered = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M6.75 4.313h9M6.75 9h9m-9 4.688h9M1.876 2.8h1.687v3.95m-1.688.563H5.25m-2.812 4.5c0-.687.615-1.23 1.327-1.107.548.094.923.615.923 1.17 0 .435-.195.848-.53 1.125l-1.147.957a1.6 1.6 0 0 0-.577 1.23h2.812" }) }))); };
export default SvgTextListNumbered;
